import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList
} from 'recharts';

const CustomLabel = ({ x, y, width, value }) => (
  <text x={x + width + 5} y={y + 10} fill="#000" fontSize={12}>
    {`${Math.round(value)}%`}
  </text>
);

const SimplePercentageChart = ({ height = 200, data, title = "Efficiency Levels" }) => (
  <div className="w-full flex flex-col items-center mt-4">
    <h2 className="text-lg font-semibold mb-2 text-[#3b3b3b]">{title}</h2>
    <ResponsiveContainer width= {400} height={height}>
      <BarChart
        layout="vertical"
        data={data}
        margin={{ top: 0, right: 0, bottom: 0, left: 25 }}
      >
        <YAxis dataKey="name" type="category" />
        <XAxis type="number" domain={[0, 100]} hide />
        <Tooltip />
        <Bar dataKey="value" fill="#3b3b3b" radius={[0, 7, 7, 0]}>
          <LabelList dataKey="value" content={CustomLabel} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  </div>
);


export default SimplePercentageChart